import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Image from "next/image";

interface NoResultProps {
  title: string;
  description?: string;
  image: string;
}

export default function NoResult({ title, description, image }: NoResultProps) {
  return (
    <Flex
      direction={"col"}
      justifyContent={"center"}
      alignItems={"center"}
      className="h-full items-center lg:mt-4"
    >
      <Typography variant="h3" className="font-semibold pb-3 text-center">
        {title}
      </Typography>
      <Typography
        variant="body1"
        className="text-muted-foreground max-md:text-center"
      >
        {description}
      </Typography>
      <Image
        src={image}
        width={400}
        height={400}
        className=" w-[300px] md:w-[400px] h-auto"
        alt="noresult"
        priority
      />
    </Flex>
  );
}
